import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./App.js";
import { ThemeProvider } from "./components/app/ThemeProvider.js";
import { PlatformBrandProvider } from "./components/app/PlatformBrandProvider.js";
import { AppErrorBoundary } from "./components/app/ErrorBoundary.js";
import { CookieConsent } from "./components/app/CookieConsent.js";
import { registerServiceWorker } from "./lib/registerSW.js";
import "./styles/globals.css";

// If the stale-asset recovery path fired in a prior page load,
// clear the one-shot guard now that we've successfully reached the
// entry module. A second stale-asset 404 later in the session (e.g.
// after a subsequent deploy while the tab is still open) will then
// be able to recover again.
try {
  sessionStorage.removeItem("exambase:stale-reload");
} catch {
  /* storage disabled — the guard just won't reset */
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element missing");
createRoot(rootEl).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <PlatformBrandProvider>
            <App />
            <CookieConsent />
            <Toaster richColors closeButton position="top-right" />
          </PlatformBrandProvider>
        </BrowserRouter>
      </ThemeProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
